<template>

  <el-form class="form-protection" ref="form" :rules="rules" :model="form" label-position="left" label-width="180px">

      <el-form-item label="Master Password" prop="password">
        <el-input v-model="form.password" type="password" />
      </el-form-item>

      <el-form-item label="Repeat Password" prop="repassword">
        <el-input v-model="form.repassword" type="password" />
      </el-form-item>

      <el-form-item size="large">
        <el-button type="primary" :loading="loading" @click="onSubmit">
          <span>Enable</span>
        </el-button>
      </el-form-item>

  </el-form>

</template>

<script>
  export default {
    components: {
    },
    props: [],

    data() {
      const validatePass = (rule, value, callback) => {
        if (value !== this.form.password) {
          callback(new Error('Passwords don\'t match!'));
        } else {
          callback();
        }
      };

      return {
        loading: false,
        form: {},
        rules: {
          password: [
            { required: true, message: 'Please enter password', trigger: 'blur' },
            { min: 6, message: 'Length should be at least 6 symbols', trigger: 'blur' }
          ],
          repassword: [
            { required: true, message: 'Please repeat your password', trigger: 'blur' },
            { min: 6, message: 'Length should be at least 6 symbols', trigger: 'blur' },
            { validator: validatePass, trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      async onSubmit() {
        if (!await this.isValid()) {
          return this.$message.error('Fill field correctly!');
        }
        this.loading = true;
        try {
          await this.$store.dispatch('enableEncryption', this.form.password);
          await this.$store.dispatch('getAccountSettings');
          this.$message.success('Saved!');
        } catch (err) {
          this.$message.error('Error: ' + err.message);
        }
        this.loading = false;
      },
      async isValid() {
        return new Promise((success) => {
          return this.$refs['form'].validate(valid => success(valid));
        });
      }
    }
  };
</script>



// WEBPACK FOOTER //
// protectionSettings.vue?20ffacf9